'use client'

import React from 'react'
import { useSearchParams } from 'next/navigation'
import AssessmentLauncher from '@/components/freetool/AssessmentLauncher'

type Tool = 'adhd' | 'asd'

const AssessmentLauncherSwitch: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const sp = useSearchParams()
  const tool = (sp.get('tool') || '').toLowerCase()

  if (tool === 'adhd' || tool === 'asd') {
    return <AssessmentLauncher tool={tool as Tool} />
  }

  return <>{children}</>
}

export default AssessmentLauncherSwitch
